// CodeMirror-dekorations-lag: et StateField der holder den aktuelle DecorationSet,
// opdateret via en StateEffect. Bruges til dimensions-farvning + segment-kobling.
import { StateField, StateEffect } from '@codemirror/state';
import { EditorView, Decoration } from '@codemirror/view';

export const setDecorations = StateEffect.define();

export const decorationField = StateField.define({
  create() { return Decoration.none; },
  update(deco, tr) {
    deco = deco.map(tr.changes);
    for (const e of tr.effects) if (e.is(setDecorations)) deco = e.value;
    return deco;
  },
  provide: (f) => EditorView.decorations.from(f),
});

// items: [{from, to, attributes, class}] -> DecorationSet (sorteret efter from).
export function buildDecorations(items, docLen) {
  const clean = items
    .filter((it) => it.from < it.to && it.from >= 0 && it.to <= docLen)
    .sort((a, b) => a.from - b.from || a.to - b.to);
  return Decoration.set(
    clean.map((it) => Decoration.mark({ attributes: it.attributes, class: it.class }).range(it.from, it.to)),
    true,
  );
}
